// extracted by mini-css-extract-plugin
export default {"spring":"spring_spring__LlPPr"};